// extracted by mini-css-extract-plugin
export default {"languagesList":"LanguageSwitcher_languagesList__RLGru","languageElement":"LanguageSwitcher_languageElement__nVK0G","currentLanguage":"LanguageSwitcher_currentLanguage__2dF8p"};